import React from 'react'
import { Alert, Button } from 'react-bootstrap'
import * as Icon from 'react-bootstrap-icons'

interface Props {
    filterLabel?: string
    onClearFilter: () => void
    onEditFilter: (e: React.MouseEvent) => void
}

function FilterBox({ filterLabel, onClearFilter, onEditFilter }: Props) {
    if (!filterLabel) {
        return <p><button className="btn btn-link p-0" onClick={onEditFilter}> Filter</button></p>
    }

    return (
        <Alert variant="info" className="filterbox">
            <Button variant="link" onClick={onEditFilter}><Icon.Pencil /></Button>
                Filter by: {filterLabel}
                <Button variant="link" onClick={onClearFilter}><Icon.XCircle /></Button>
        </Alert>
    )
}

export default FilterBox
